export default __webpack_public_path__ + "static/media/guest-login-bg.b28c6edf.png";